import { useEffect } from 'react';
import { useSiteSettings } from '../../hooks/useSiteSettings';

// Tab logo (favicon) — header logo nai browser tab ma dekhincha
function Favicon() {
  const settings = useSiteSettings();
  const logo = settings.header_logo || settings.mininav_logo || settings.footer_logo;

  useEffect(() => {
    if (!logo) return;
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.type = 'image/png';
    link.href = logo;
  }, [logo]);

  return null;
}

export default Favicon;
